<template>
  <div v-show="isCardActiveLocal">
    <div class="clickpagequizviewer">
      <div class="vx-row" v-if="question">
        <div class="vx-col w-full mb-2 textcenter">
          <h3>{{ question ? question.title : "" }}</h3>
        </div>
      </div>
      <div class="vx-row" v-if="question">
        <div class="vx-col w-full mb-2 textcenter">
        <div style="overflow-wrap: break-word; word-wrap: break-word; word-break: break-word;" v-html="question.questionText"></div>
        </div>
      </div>

      <div v-if="question.imageUrl" class="quizimage">
        <img :src="question.imageUrl" class="clickimageactive" style="width: 100% !important; height: 100%; border-radius:15px;">
      </div>
    </div>

    <div class="vx-row pt-3 paddingbot">
    <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-full xl:w-1/3 w-full"></div>
      <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-full xl:w-1/3 w-full">
        <div v-if="question">
          <ul>
            <li v-for="(option, index) in question.options" :key="index">
              <div class="vx-row pt-3 ml-2">
                <div class="vx-col w-full">
                  <div class="flex multipleselectbutton">

                    <div class="self-center mr-2">
                      <span v-if="option.isSelected"><feather-icon class="pt-1" icon="CheckSquareIcon" svg-classes="stroke-current"></feather-icon></span>
                      <span v-else><feather-icon class="pt-1" icon="SquareIcon" svg-classes="stroke-current"></feather-icon></span>
                    </div>

                    <button
                      class="buttons resizeimage"
                      :class="option.isSelected ? 'button_true':'button_false'"
                      size="large"
                      style="border-radius:15px; word-break: break-word;"
                      v-html="option.optionText"
                      @click="changeInput(index)"
                      :disabled="disableUnchecked && !option.isSelected"
                      >
                    </button>

                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      question: {
        type: Object,
        required: false
      },
      isQuizJournal: {
        type: Boolean,
        required: false
      },
      isStudent: {
        type: Boolean,
        required: false
      },
      isStandalone: {
        type: Boolean,
        required: false
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          if(!self.isQuizJournal){
            self.question.options.forEach(function(option, index){
              option.isSelected = false
            })
          }
          
          self.$emit("initValues");
        }
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            this.$emit("initValues");
          }
        }
      },
      disableUnchecked: function() {
        if(this.question.responseLimit != 0 && this.question.options.filter(function(item){ return item.isSelected }).length == this.question.responseLimit){
          return true;
        }
        return false;
      },
    },
    methods:{
      changeInput(index){
        this.question.options[index].isSelected = !this.question.options[index].isSelected;
      }
    },
  };
</script>

<style lang="scss">
  label::before , label::after{
    top: 0px !important ;
  }

  .resizeimage{
    z-index: 2;
    img{
      padding: 10px;
      max-width: 15vw;
      width: 100%;
    }
  }

  // @media only screen and (max-width: 700px){    
  //   .resizeimage{
  //     z-index: 2;
  //     img{
  //       max-width: 50%;
  //       transition: 500ms ease-in-out;
  //     }
  //     &:hover{
  //       img{
  //         width: 100%;
  //         height: 100%;
  //         max-width: 100%;
  //       }
  //         p img{
  //         width: 100%;
  //         height: 100%;
  //         max-width: 100%;
  //       }
  //     }
  //   }
  // }

  

  #answerTextArea {
    height: 200px;
  }

  #answerTextArea {
    .vs-component.vs-con-textarea.vs-textarea-primary{
    border-color: rgb(48, 48, 48) !important;
    }
  }

  .textcenter{
    text-align: center !important;
  }

  .quizimage{
    width: 40%;
    max-height: 60%;
    display: flex;
    justify-content: center;
    margin: 0 auto;
    padding: 20px 0px;
  }

  @media screen and (max-width: 500px) {
    .quizimage{
      width: 80%;
      max-height: 90%;
    }
  }

  .check_container {
    .p-smooth.pretty[p-checkbox] {
      .state {
        .icon.feather {
          top: 0 !important;
          left: 1px !important;
        }
      }
    }
  }

  .paddingbot{
    padding-bottom: 5%;
  }

  .buttons{
      width: 100%;
      background-color: white;
      box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
      border: none !important;
      text-align: left;
      padding: 20px;

      transition: all .2s ease-in-out;
    }

  .multipleselectbutton{
    &:hover{
      transform: scale(1.05);
    }
  }

</style>
